import React, { useEffect, useState } from "react";
import AddIcon from "../../assets/icons/addIcon";
import searcher from "../../assets/searchInput.svg";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import DistributorTable from "./distributorTable";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const DistributorList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const [linkShow, setLinkShow] = useState(false);
  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  const is_subscribed = localStorage.getItem("is_subscribed");

  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Distributor" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/distributors/onboarded",
      breadcrumb: " / distributors / onboarded distributors",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div className="">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div className="search-box d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} alt="o" />
                <input
                  className="search-input text-dark fw_400 px-2"
                  type="text"
                  placeholder="Search distributor id, Name etc,."
                  onChange={(e) => {
                    navigate(
                      `/distributors/onboarded?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }${queryString}`
                    );
                  }}
                  value={search}
                />
              </div>
              <div className=" d-flex justify-content-center  m-1 mb-2">
                {(user_type === "super_user" && userData?.write) ||
                user_type === "vendor" ? (
                  <>
                    <button
                      onClick={() => navigate(`/distributors/onboarded`)}
                      className="py-1 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                    >
                      Clear Filters
                    </button>
                    <AdminButton
                      background="#7065E4"
                      color="white"
                      width="190px"
                      onClick={() => setLinkShow(true)}
                    >
                      <AddIcon />
                      <span className="m-2"> LINK DISTRIBUTOR</span>
                    </AdminButton>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <DistributorTable
              search={search}
              linkShow={linkShow}
              linkClose={() => setLinkShow(false)}
              is_subscribed={is_subscribed}
              status={status}
              page_no={page_no}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorList;
